import React from 'react';
import { gettext } from "@eb/i18n";
import {
    COMPARE_PACKAGES_PATH,
    COMPARE_PACKAGES_TEXT,
    CONTACT_SALES_DESCRIPTION_TEXT,
    CUSTOM_PRICING,
    DEFAULT_PACKAGE_TYPES,
    DEFAULT_PACKAGES,
    ESSENTIALS_DESCRIPTION_TEXT,
    FINE_PRINT_WITH_FIXED_FEE,
    GET_STARTED_FREE_TEXT,
    GET_STARTED_TEXT,
    LETS_TALK_TEXT,
    PACKAGE_DESCRIPTIONS,
    PACKAGE_ONE,
    PACKAGE_ONE_NAME,
    PACKAGE_THREE,
    PACKAGE_THREE_NAME,
    PACKAGE_TWO,
    PACKAGE_TWO_NAME,
    PER_PAID_TICKET_TEXT,
    PRICE_PER_PAID_TICKET,
    PROFESSIONAL_DESCRIPTION_TEXT,
} from '../../constants/main';
import {
    PACKAGE_ONE_FEATURES,
    PACKAGE_THREE_FEATURES,
    PACKAGE_THREE_FEATURES_US,
    PACKAGE_TWO_FEATURES_ALL,
} from '../../constants/features';
import {
    CHANGE_PACKAGE,
    FREE_OPTION,
    PACKAGE_DIFFER,
    PAY_FEES,
    PAYMENT_OPTIONS,
    PRIVATE_EVENT,
    TICKET_TYPE,
    TICKETING_ESSENTIALS,
} from '../../constants/faqs';
import {
    BRANDED_PAGES,
    CUSTOMER_SUPPORT,
    CUSTOMIZABLE_CHECKOUT_FORMS,
    DETAIL_SALES_ANALYTICS,
    LISTING_PARTNER_SITES,
    ONSITE_RENTAL_SUPPORT,
    TICKET_SALES_SITE,
    TICKET_TYPES,
    TR_ESSENTIALS,
} from '../../constants/signupFeatures';
import {
    PRICE_PER_FREE_TICKET,
    PRODUCT_TRAINING,
} from '../../constants/featuresComparison';
import { STYLE_FILL, STYLE_NEUTRAL } from '@eb/eds-button';

import { BookRoundIllustration } from '@eb/eds-iconography';

export default {
    grid: {
        packages: DEFAULT_PACKAGES,
        packageTypes: DEFAULT_PACKAGE_TYPES,
        primaryHeading: gettext("Find the solution that's right for you"),
        secondaryHeading: gettext(
            'Avoid ticketing fees by passing them to attendees',
        ),
        featureDescriptions: PACKAGE_DESCRIPTIONS,
        feeBreakdownOverride: {
            [PACKAGE_THREE]: {
                formattedFee: gettext('Custom'),
            },
        },
        extraMainFeatures: [
            CUSTOMER_SUPPORT,
            TICKET_TYPES,
            TR_ESSENTIALS,
            LISTING_PARTNER_SITES,
            TICKET_SALES_SITE,
            CUSTOMIZABLE_CHECKOUT_FORMS,
            DETAIL_SALES_ANALYTICS,
            ONSITE_RENTAL_SUPPORT,
            BRANDED_PAGES,
            PRODUCT_TRAINING,
        ],
        CTAs: [GET_STARTED_TEXT, GET_STARTED_TEXT, LETS_TALK_TEXT],
        CTAStyles: [STYLE_NEUTRAL, STYLE_FILL, STYLE_NEUTRAL],
        showFinePrint: false,
        finePrint: gettext(''),
        pricePerPaidTicket: PRICE_PER_PAID_TICKET,
        pricePerFreeTicket: PRICE_PER_FREE_TICKET,
        shouldShowAnnualFee: false,
    },
    packagesList: {
        heading: gettext("Find the package that's right for you"),
        secondaryHeading: gettext(
            'You can avoid fees by passing them to attendees.',
        ),
        packages: {
            [PACKAGE_ONE]: {
                name: PACKAGE_ONE_NAME,
                description: ESSENTIALS_DESCRIPTION_TEXT,
                priceDescription: gettext('Free for free tickets'),
                features: PACKAGE_ONE_FEATURES,
                secondaryCTA: COMPARE_PACKAGES_TEXT,
                packagePath: COMPARE_PACKAGES_PATH,
                isProminentPackage: false,
                logoBgColor: 'grey-900',
                logoImg: 'pricing/logo-essentials',
                logoWidth: 142,
                logoHeight: 35,
            },
            [PACKAGE_TWO]: {
                name: PACKAGE_TWO_NAME,
                description: PROFESSIONAL_DESCRIPTION_TEXT,
                priceDescription: gettext('Free for free tickets'),
                includeOtherFeatures: true,
                features: PACKAGE_TWO_FEATURES_ALL,
                secondaryCTA: COMPARE_PACKAGES_TEXT,
                packagePath: COMPARE_PACKAGES_PATH,
                isProminentPackage: true,
                logoBgColor: 'ui-orange',
                logoImg: 'pricing/logo-professional',
                logoWidth: 257,
                logoHeight: 30,
            },
            [PACKAGE_THREE]: {
                name: PACKAGE_THREE_NAME,
                description: CONTACT_SALES_DESCRIPTION_TEXT,
                includeOtherFeatures: true,
                priceDescription: CUSTOM_PRICING,
                features: PACKAGE_THREE_FEATURES_US,
                secondaryCTA: COMPARE_PACKAGES_TEXT,
                packagePath: COMPARE_PACKAGES_PATH,
                isProminentPackage: false,
                logoBgColor: 'white',
                logoImg: 'pricing/logo-premium',
                logoWidth: 155,
                logoHeight: 61,
            },
        },
        CTAs: [GET_STARTED_FREE_TEXT, GET_STARTED_FREE_TEXT, LETS_TALK_TEXT],
        CTAStyles: [STYLE_NEUTRAL, STYLE_FILL, STYLE_NEUTRAL],
        perPaidTicketText: PER_PAID_TICKET_TEXT,
        finePrint: FINE_PRINT_WITH_FIXED_FEE,
    },
    faqs: {
        heading: gettext('Frequently asked questions'),
        bannerHeading: gettext(
            "Don't see a feature you need? There's a lot more under the hood.",
        ),
        bannerCTA: gettext('Compare all features'),
        illustration: <BookRoundIllustration />,
        faqs: [
            CHANGE_PACKAGE,
            TICKET_TYPE,
            FREE_OPTION,
            TICKETING_ESSENTIALS,
            PACKAGE_DIFFER,
            PRIVATE_EVENT,
            PAY_FEES,
            PAYMENT_OPTIONS,
        ],
    },
};
